// Idioma de la interfaz, resuelto siempre a "es" o "en".
//
// Vive aqui, y no dentro de un componente, porque hace falta en dos puntos que no
// pueden leer `LangContext`: `clearSessionData` (modulo plano) y
// `SessionExpirationBoundary` (monta por encima de los providers, en index.js).
// El resto de la aplicacion ya tiene `lang` en contexto y solo necesita
// normalizarlo; la comparacion con `startsWith("es")` estaba copiada en una
// veintena de archivos y aqui queda una sola definicion.

export const LANGUAGE_STORAGE_KEY = "language";

export const normalizeInterfaceLanguage = (language) =>
  String(language ?? "")
    .toLowerCase()
    .startsWith("es")
    ? "es"
    : "en";

export const isSpanishInterface = (language) =>
  normalizeInterfaceLanguage(language) === "es";

// `setLocalItem` guarda con JSON.stringify, asi que el valor almacenado llega
// entrecomillado ('"es"'). Se lee en crudo y se limpian las comillas para no
// depender de esa forma ni de que JSON.parse tenga exito.
export const readStoredInterfaceLanguage = () => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return normalizeInterfaceLanguage(String(stored ?? "").replace(/"/g, ""));
  } catch {
    return "en";
  }
};
